import React, { useState } from 'react';
import { useEffect } from 'react';
import {
    Alert,
    Form,
    Modal
} from 'react-bootstrap';
import '../../../../styles/PasswordModal.css';
import { HHIEButton } from '../../../utility/HHIEButton';
import Loading from '../../../utility/Loading';
import { HHIEError } from '../../../utility/HHIEError';
import { HHIEPasswordRequirements } from '../../../utility/HHIEPasswordRequirements';

export const PasswordChangeModal = (props) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMessage] = useState();
    const [success, setSuccess] = useState(false);
    const [pocid, setPocId] = useState();
    const [currentPassword, setCurrentPassword] = useState();
    const [password, setPassword] = useState();
    const [confirmPassword, setConfirmPassword] = useState();
    const [pwdLength, setPwdLength] = useState();
    const [show, setShow] = useState(false);

    useEffect(() => {
        setLoading(true);
        try {
            const user = JSON.parse(sessionStorage.getItem("user"));
            if (user === null) {
                handleError("You must be associated with an account for this portion.");
                setTimeout(() => { window.location.href = '/login' }, 3000);
                return;
            }
            if (user.pocid === 0) {
                handleError("You must be associated with an account for this portion.");
                setTimeout(() => { window.location.href = '/login' }, 3000);
                return;
            }
            if (!user.securityQuestionsComplete) {
                handleError("You need to complete your security questions.");
                setTimeout(() => { window.location.href = '/set-security-questions' }, 3000);
                return;
            }
            if (user.passwordIsTemporary) {
                handleError("You've already reset your password, please login.");
                setTimeout(() => { window.location.href = '/login' }, 3000);
                return;
            }
            setPocId(user.pocid);
        }
        catch (ex) {
            console.log(ex);
        }
        // get password length from db
        fetch('api/login/required-pwd-length')
            .then(response => {
                response.json()
                    .then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                    setPwdLength(json.message);
                })
                .catch(ex => {
                    console.log(ex);
                });
            })
            .catch(ex => {
                console.log(ex);
            });
        setLoading(false);
        
    }, [])

    const handleError = (message) => {
        setError(true);
        setErrorMessage(message);
    }
    // pw validators
    const checkForUpperCase = (word) => hasCharacter(/^[A-Z]+$/, word);
    const checkForLowerCase = (word) => hasCharacter(/^[a-z]+$/, word);
    const checkForNumber    = (word) => hasCharacter(/^[0-9]+$/, word);
    const checkForSymbol = (word) => hasCharacter(/[-!@#$%^&*()_+=/\u0020]/, word);
    const checkForNonCompliantSymbol = (word) => hasCharacter(/[^A-Za-z0-9-!@#$%^&*()_+=/\u0020]/, word);
    const hasCharacter = (regex, word) => {
        let hasCharacter = false;
        if (word.length > 0) {
            for (var i = 0; i<word.length; i++) {
                var letter = word.charAt(i);
                if (letter.match(regex)) {
                    hasCharacter = true;
                    break;
                }
            }
        }
        return hasCharacter;
    };
    // SUBMIT
    const handleSubmit = async () => {
        const pwd = password ? password : "";
        const conPwd = confirmPassword ? confirmPassword : "";

        if (pwd === conPwd) {
            if (pwd.length >= pwdLength 
                && checkForLowerCase(pwd)
                && checkForUpperCase(pwd) 
                && checkForNumber(pwd) 
                && checkForSymbol(pwd)
                && !checkForNonCompliantSymbol(pwd)) 
            {
                
                if (pocid === null || pocid === 0) {
                    handleError("Something went wrong. Please contact the HHIE.");
                    return;
                }
                const formData = new FormData();
                formData.append("pocid", pocid);
                formData.append("currentPassword", currentPassword);
                formData.append("password", password);
                formData.append("confirmPassword", confirmPassword);
                const requestOptions = {
                    method: 'POST',
                    body: formData
                }
                const success = await fetch('api/user/PocUserSetsAndChangesPasswordOnModal', requestOptions)
                    .then(async (response) => {
                        try {
                            return await response.json().then(json => {
                                if (json.errors !== null && json.errors !== "") alert(json.errors)
                                return json.message;
                            });
                        }
                        catch (ex) {
                            handleError(ex);
                            return console.log(ex);
                        }
                    })
                    .catch(ex => console.log(ex));
                if (success) {
                    setSuccess(true);
                    setError(false);
                    sessionStorage.clear();
                }
                else {
                    handleError("Bad Password. Try again.");
                }
            } else {
                handleError("Invalid Password. Please check password requirements above.");
            }
        } else {
            handleError("Passwords do not match. Try again.");
        }
        
    };
    const handleClose = () => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
        setPassword(null);
        setCurrentPassword(null);
        setConfirmPassword(null);
        setLoading(false);
        setShow(false); 
    }
    return (
    <>
        <HHIEButton
            title="Change Password"
            size="sm"
            onClick={() => { setShow(true); }}
        />
        <Modal
            backdrop="static"
            show={show}
            onHide={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage(null);
                setPassword(null);
                setCurrentPassword(null);
                setConfirmPassword(null);
                setLoading(false);
                setShow(false);
            }}
            keyboard={false}
            centered
        >
            {loading && <Loading message="Please wait while we load your information..." />}
            {!loading && !success &&
            <div style={{margin: 'auto'}}>
                <Modal.Header>
                    <Modal.Title style={{margin: 'auto'}}>
                        Change Password
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group key="set-password">
                            <Form.Label>Enter your Current Password</Form.Label>
                            <Form.Control
                                id="set-current-password"
                                type="password"
                                onChange={(e) => {
                                    setCurrentPassword(e.target.value);
                                }}
                            />
                            <br />
                            <HHIEPasswordRequirements 
                                pwdLength={pwdLength}
                                password={password}
                                confirmPassword={confirmPassword}
                            />
                            <Form.Label>Please enter your New Password</Form.Label>
                            <Form.Control
                                id="set-password"
                                type="password"
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                }}
                            />
                            <br />
                            <Form.Label>Please confirm your New Password</Form.Label>
                            <Form.Control
                                id="set-confirm-password"
                                type="password"
                                onChange={(e) => {
                                    setConfirmPassword(e.target.value);
                                }}
                            />
                        </Form.Group>
                    </Form>
                    {error &&
                        <HHIEError 
                            message={errorMsg} 
                            onClick={() => { 
                                setError(false); 
                                setErrorMessage(""); 
                            }} 
                        />
                    }
                </Modal.Body>
                <Modal.Footer>
                        {!success && 
                        <HHIEButton
                            id="reset-pwd-btn"
                            size="sm"
                            title="Change Password"
                            onClick={handleSubmit}
                        />}
                        <HHIEButton
                            id="close-reset-pwd-modal"
                            size="sm"
                            title="Close"
                            variant="danger"
                            onClick={() => {
                                handleClose();
                            }}
                        />
                </Modal.Footer>
            </div>
            }
            {success &&
                <Alert variant="success" id="password-changed-alert">You have successfully reset your password, please <Alert.Link href="/login">login</Alert.Link> with your new password.</Alert>
            }
        </Modal>
    </>
    );
}